















































































import Vue from "vue";
import Modal from "@/components/root/modal/Modal.vue";
import EmailsBox from "@/components/email-box/EmailsBox.vue";
import { ModalConfig } from "@/components/root/modal";
import { computed, ref, Ref, onMounted } from "@vue/composition-api";
import { createAdmins } from "../data/api";
import { AppAnalytics } from "@/analytics";
import { trackAdminInvite } from "../data/admin-analytics";
import { UseToast, ToastType } from "@/components/root/toast/toast.state";
import DropDownSimple from "@/components/dropdown/DropDownSimple.vue";
import AdminScope from "../AdminScope.vue";

import { includes_all } from "@/fp";
import {
  all_restrictions,
  apps_as_list,
} from "@/common/models/admin-restrictions.model";
import { removed_admins, restore_removed_admins } from "../data/state";
type InviteCallStatus = "idle" | "success" | "failure" | "partialSuccess";

export default Vue.extend({
  components: {
    Modal,
    EmailsBox,
    DropDownSimple,
    AdminScope,
  },
  props: ["modalData"],
  setup(props, { emit }) {
    const isLoading = ref(false);
    const emails: Ref<string[]> = ref([]);
    const status: Ref<InviteCallStatus> = ref("idle");
    const showErrorMsg = ref(false);
    const parentHeight = ref("auto");

    const restrictions: Ref<string[]> = ref([...all_restrictions]);

    const is_all_info_types_unchecked = computed(
      () =>
        restrictions.value.reduce((acc, item) => {
          if (item.startsWith("it")) {
            acc++;
          }
          return acc;
        }, 0) === 7
    );

    const is_all_entity_types_unchecked = computed(
      () =>
        restrictions.value.reduce((acc, item) => {
          if (item.startsWith("et")) {
            acc++;
          }
          return acc;
        }, 0) === 5
    );

    const all_apps_codes = apps_as_list().map((d) => d.id);
    const includes_all_apps = includes_all(all_apps_codes);
    const is_all_apps_unchecked = computed(() =>
      includes_all_apps(restrictions.value)
    );

    const mainEl: Ref<HTMLElement | null> = ref(null);

    const closeOutside = computed(() => !isLoading.value);
    const disableSave = computed(
      () =>
        emails.value.length === 0 ||
        (current_admin_type.value.id === "business" &&
          (is_all_entity_types_unchecked.value ||
            is_all_info_types_unchecked.value))
    );

    const linkValue = ref("");

    onMounted(async () => {
      AppAnalytics.report({
        component: "Admins",
        eventName: "Cognni_Admin[Action:Open Invite Admin]",
      });
      linkValue.value = location.origin + "/login";
    });

    const config = computed(() => {
      return {
        withTopRightCloseBtn: true,
        title: showCopyLinkUi.value ? "Admin Added!" : "Invite Admins",
        desc: showCopyLinkUi.value
          ? "Copy the link below and send to the contacts you invited."
          : 'Please enter a valid Microsoft email address and hit "Enter"',
        width: showCopyLinkUi.value ? "40rem" : "73rem",
        height: showCopyLinkUi.value
          ? "auto"
          : current_admin_type.value.id === "business"
          ? "70rem"
          : "auto",
        cancelBtnText: "cancel",
        submitBtnText: showCopyLinkUi.value ? "done" : "next",
        isLoading: isLoading.value,
        disableSave: disableSave.value,
        backdropDismiss: closeOutside.value,
      } as ModalConfig;
    });

    const admin_types = ref([
      { id: "system", name: "Super Admin" },
      { id: "business", name: "Business Unit Admin" },
    ]);

    const current_admin_type = ref(admin_types.value[0]);

    const close = () => {
      AppAnalytics.report({
        component: "Settings",
        eventName: "Settings_Cognni admins_invite admin_cancel button",
      });
      emit("cancel");
    };
    const onEmails = (_emails: string[]) => (emails.value = [..._emails]);

    const calcParentHeight = (): string => {
      parentHeight.value =
        getComputedStyle(mainEl.value as HTMLElement).height || "auto";
      return parentHeight.value;
    };

    const showCopyLinkUi = computed(() => status.value === "success");

    const filter_out_removed_admins = (
      emails: string[]
    ): [string[], string[]] => {
      const removed_emails = removed_admins.value.map((d) => d.email);
      // keep emails that doesn't exist in the admins that were removed.
      const emails_to_send = emails.filter(
        (email) => !removed_emails.includes(email)
      );
      const admins_to_restore = removed_admins.value
        .filter((a) => emails.includes(a.email))
        .map((s) => s.email);
      return [emails_to_send, admins_to_restore];
    };

    /**
     * @description send email to the following users.
     */
    const sendEmails = async () => {
      if (showCopyLinkUi.value) {
        emit("cancel");
      } else {
        AppAnalytics.report({
          component: "Admins",
          eventName: "Cognni_Admin[Action:Invite Admin]",
        });
        /*
         * Woopra event for the invite. This branch is only reached by the Next
         * button, which the modal disables while `disableSave` holds — so a
         * cancelled dialog or a failed validation never gets here, as required.
         * Fired on the click rather than on the API response, because the
         * ticket ties the event to the action the user took.
         */
        trackAdminInvite({
          emails: [...emails.value],
          role_id: current_admin_type.value.id,
          role_name: current_admin_type.value.name,
        });
        calcParentHeight();
        showErrorMsg.value = false;
        try {
          isLoading.value = true;

          // remove the admins that are in the
          // admins list but are in blocked status
          const [emails_to_send, admins_to_restore] = filter_out_removed_admins(
            emails.value
          );

          const res = await createAdmins({
            emails: emails_to_send,
            restrictions:
              current_admin_type.value.id === "business"
                ? restrictions.value.length === 0
                  ? ["ar01", "ar02"]
                  : ["ar01", "ar02", ...restrictions.value]
                : [],
          });

          if (admins_to_restore.length > 0) {
            await restore_removed_admins(admins_to_restore);
          }

          status.value = res.success ? "success" : "failure";
          if (res.success) {
            emails.value.forEach((email) => {
              AppAnalytics.report({
                component: "Admins",
                eventName: "Cognni_Admin[Action:Invite Admin]_success",
                payload: {
                  email,
                  restrictions: restrictions.value,
                },
              });
            });
          }
        } catch (errCode) {
          status.value = "failure";
        } finally {
          isLoading.value = false;
        }
      }
    };

    const isLinkCopied = ref(false);

    const copyLink = () => {
      const el = document.createElement("textarea");
      el.value = linkValue.value;
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      isLinkCopied.value = true;
      //emit("submit");
      UseToast().show({
        type: ToastType.SUCCESS,
        msg: "Link copied to clipboard",
        duration: 3000,
      });
    };

    return {
      restrictions,
      config,
      admin_types,
      current_admin_type,
      close,
      sendEmails,
      mainEl,
      onEmails,
      status,
      showErrorMsg,
      showCopyLinkUi,
      copyLink,
      isLinkCopied,
      linkValue,
      is_all_info_types_unchecked,
      is_all_entity_types_unchecked,
    };
  },
});
